module.exports = __webpack_public_path__ + "img/Jakarta - A city on the move.1e46e1cd.png";